<template>
  <div class="electricity-trend-month">
    <div class="title">月用电趋势统计</div>
    <div class="query-condition">
      <div class="condition-row">
        <div class="label">建筑</div>
        <el-select v-model="buildingData" clearable placeholder="请选择" @change="queryData">
          <el-option v-for="item in buildingArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="condition-row">
        <div class="label">月份</div>
        <el-date-picker v-model="monthDate" type="month" value-format="yyyy-MM" :clearable="clearFlag" @change="queryData"
          placeholder="选择月"></el-date-picker>
      </div>
    </div>
    <div class="chart-box">
      <div id="monthTrendsChart" style="width: 100%; height: 90%"></div>
    </div>
  </div>
</template>

<script>
import { Dates } from "$utils";
import eCharts from "echarts"
export default {
  name: 'ElectricityTrendMonth',
  data() {
    return {
      buildingData: '',
      monthDate: Dates.format(new Date(), "yyyy-MM"),
      buildingArr: [],
      clearFlag: false,
      monthTrendsChart: null,
      monthTrendsChartOpt: {},
      xData: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17'
        , '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      yDataA: [],
      yDataB: [],
      yDataC: [],
      yDataD: []
    }
  },
  created() {
    this.queryBuildList()
    this.queryData()
  },
  mounted() {
    window.onresize = () => {
      this.monthTrendsChart.resize()
    };
  },
  methods: {
    async queryBuildList() {
      const { success, returnObj } = await this.$fetch("/bms/energyMeterInfo/getBuildList")
      if (success) {
        this.buildingArr = returnObj.map(v => {
          return {
            label: v.name,
            value: v.id
          }
        })
      }
    },
    async queryData() {
      const { success, returnObj } = await this.$fetch('/bms/energyMeterDataInfo/getVPFDataList' + '?buildId=' + this.buildingData + '&date=' + this.monthDate + '&type=1')
      if (success) {
        if (returnObj && returnObj.length > 0) {
          this.xData = []
          this.yDataA = []
          this.yDataB = []
          this.yDataC = []
          this.yDataD = []
          returnObj.forEach(v => {
            let tempDate = v.date.split('-')
            this.xData.push(tempDate[2])
            this.yDataA.push(v.use)
            this.yDataB.push(v.pUse)
            this.yDataC.push(v.fFUse)
            this.yDataD.push(v.vUse)
          })
        } else {
          this.xData = ['0']
          this.yDataA = []
          this.yDataB = []
          this.yDataC = []
          this.yDataD = []
        }
        this.initBuildingPowerChart()
      } else {
        this.xData = ['0']
        this.yDataA = []
        this.yDataB = []
        this.yDataC = []
        this.yDataD = []
        this.initBuildingPowerChart()
      }
    },
    initBuildingPowerChart() {
      let chartDom = document.getElementById("monthTrendsChart");
      this.monthTrendsChart = eCharts.init(chartDom);
      this.monthTrendsChartOpt = {
        color: ['#00ffff', '#f68181', '#a797f7', '#59dd98'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // data: ['当月', '上月'],
          icon: "rect",
          itemHeight: 12,
          itemWidth: 25,
          right: 40,
          top: 10
        },
        grid: {
          left: '4%',
          right: '5%',
          bottom: '0',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          name: '日',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          },
          // axisLabel: {
          //   interval: 0,//横轴信息全部显示
          //   rotate: -50,// -20度角倾斜显示
          // },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
        },
        series: [
          {
            name: '总量',
            type: 'line',
            smooth: true,
            data: this.yDataA
          },
          {
            name: '高峰',
            type: 'line',
            smooth: true,
            data: this.yDataB
          },
          {
            name: '平时',
            type: 'line',
            smooth: true,
            data: this.yDataC
          },
          {
            name: '低谷',
            type: 'line',
            smooth: true,
            data: this.yDataD
          }
        ]
      }
      this.monthTrendsChart.setOption(this.monthTrendsChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.electricity-trend-month {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    padding: 0 10px;
  }

  .query-condition {
    display: flex;
    justify-content: flex-end;
    margin: 0 10px;

    .condition-row {
      display: flex;
      align-items: center;

      .label {
        margin: 0 15px;
      }
    }
  }

  .chart-box {
    flex: 1;
    margin: 10px 10px 0 10px;
  }
}
</style>